import { render, staticRenderFns } from "./SprintAnalytics.vue?vue&type=template&id=20942a0c&"
import script from "./SprintAnalytics.vue?vue&type=script&lang=js&"
export * from "./SprintAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SprintAnalytics.vue?vue&type=style&index=0&id=20942a0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports